import { Box, Paper, Typography } from "@mui/material";
import type { ReactNode } from "react";

export const metricRowSx = {
	alignItems: "start",
	display: "grid",
	gap: 1.5,
	gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
	minWidth: 0,
} as const;

interface ConsumptionCardProps {
	area: string;
	label: string;
	title?: ReactNode;
	upper: ReactNode;
	lower: ReactNode;
}
export const ConsumptionCard = ({
	area,
	label,
	title,
	upper,
	lower,
}: ConsumptionCardProps) => (
	<Paper
		variant="outlined"
		role="group"
		aria-label={label}
		sx={{
			containerType: "inline-size",
			display: "grid",
			gridArea: area,
			gridTemplateRows: "minmax(116px, max-content) max-content",
			maxWidth: "100%",
			minWidth: 0,
			p: 1.25,
		}}
	>
		<Box
			sx={{
				alignContent: "start",
				display: "grid",
				gap: 0.75,
				minWidth: 0,
				pb: 1.25,
			}}
		>
			<Typography
				component="div"
				sx={{
					color: "#48525C",
					fontSize: "0.75rem",
					fontWeight: 500,
					lineHeight: 1.35,
					minHeight: "1.35em",
				}}
			>
				{title}
			</Typography>
			<Box sx={{ minWidth: 0 }}>{upper}</Box>
		</Box>
		{lower && (
			<Box
				sx={{
					borderColor: "rgba(0, 0, 0, 0.2) !important",
					borderTop: 0.5,
					minWidth: 0,
					pt: 1.25,
				}}
			>
				{lower}
			</Box>
		)}
	</Paper>
);
